import React, { useState } from "react";

const ComponentGames = () => {
  const [games] = useState([
    {
      name: "Snake",
      src: "/snakegame/snake.html",
      img: "/snakegame/snake.jpg",
    },
    {
      name: "Ninja",
      src: "/NinjaGame/index.html",
      img: "/NinjaGame/ninja.png",
    },
    {
      name: "Connect",
      src: "/ConnectFour/index.html",
      img: "/ConnectFour/connection.png",
    },
    {
      name: "Blocks",
      src: "/BlockGame/index.html",
      img: "/BlockGame/block.png",
    },
    {
      name: "DotShooter",
      src: "/DotShooter/index.html",
      img: "/DotShooter/DotShooter.png",
    },
    {
      name: "HyperSpace",
      src: "/HyperSpace/index.html",
      img: "/HyperSpace/HyperSpace.png",
    },
    {
      name: "HeroGame",
      src: "/HeroGame/index.html",
      img: "/HeroGame/hero.png",
    },
    {
      name: "SpaceCapture",
      src: "/SpaceCapture/index.html",
      img: "/SpaceCapture/SpaceCapture.png",
    },
    {
      name: "CircuitGame",
      src: "/CircuitGame/index.html",
      img: "/CircuitGame/Circuit.png",
    },
  ]);

  // useEffect(() => {
  //   fetchGamesList();
  // }, []);

  // const fetchGamesList = async () => {
  // try {
  //const response = await fetch("../GamesList.json");
  //const data = await response.json();
  //   setGames(GamesList);
  // } catch (error) {
  //  console.error("Error fetching games list:", error);
  // }
  //};

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

  return (
    <div className="container">
      <br />
      <h3 className="text-white">Awesome Games🕹️</h3>
      <div className="lynx-tile-grid">
        {games.map((game, index) => (
          <button
            className="lynx-tile"
            key={index}
            onClick={() => openInNewTab(game.src)}
          >
            <img src={game.img} alt={game.name} />
            {game.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ComponentGames;
